module.exports = __webpack_public_path__ + "assets/b59367305dbecc06c14cbaed60902cf4.svg";